import React, { useMemo } from 'react';
import { LoanOfficerMetrics } from '../../types/throughput';
import { Card } from '../ui/Card';
interface TeamSummaryBarProps {
  metrics: LoanOfficerMetrics[];
}
export function TeamSummaryBar({
  metrics
}: TeamSummaryBarProps) {
  const stats = useMemo(() => {
    if (!metrics.length) return null;
    const pullThroughs = metrics.map(m => m.conversion.createdToFunded);
    const cleanPcts = metrics.map(m => m.cleanFiles.percentage);
    const dials = metrics.map(m => m.avgDialsPerClaim);
    const costs = metrics.map(m => m.costPerFunding);
    const avg = (arr: number[]) => arr.reduce((a, b) => a + b, 0) / arr.length;
    return {
      pullThrough: {
        avg: avg(pullThroughs),
        min: Math.min(...pullThroughs),
        max: Math.max(...pullThroughs)
      },
      cleanPct: {
        avg: avg(cleanPcts),
        min: Math.min(...cleanPcts),
        max: Math.max(...cleanPcts)
      },
      dials: {
        avg: avg(dials),
        min: Math.min(...dials),
        max: Math.max(...dials)
      },
      cost: {
        avg: avg(costs),
        min: Math.min(...costs),
        max: Math.max(...costs)
      }
    };
  }, [metrics]);
  if (!stats) return null;
  const StatBlock = ({
    label,
    avg,
    min,
    max,
    format,
    reverse = false
  }: any) => <div className="flex flex-col" data-id="element-240">
      <span className="text-xs font-medium text-[#706E6B] mb-1" data-id="element-241">{label}</span>
      <div className="flex items-baseline gap-2" data-id="element-242">
        <span className="text-xl font-semibold text-[#181818]" data-id="element-243">
          {format(avg)}
        </span>
        <span className="text-xs text-[#A0A0A0]" data-id="element-244">avg</span>
      </div>
      <div className="text-[11px] text-[#706E6B] mt-1" data-id="element-245">
        Spread:{' '}
        <span className={reverse ? 'text-[#EA001E]' : 'text-[#04844B]'} data-id="element-246">
          {format(reverse ? max : min)}
        </span>{' '}
        to{' '}
        <span className={reverse ? 'text-[#04844B]' : 'text-[#EA001E]'} data-id="element-247">
          {format(reverse ? min : max)}
        </span>
      </div>
    </div>;
  return <Card className="mb-6 p-4 bg-white border border-[#E5E5E5] shadow-sm" data-id="element-248">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:divide-x divide-[#E5E5E5]" data-id="element-249">
        <div className="px-4" data-id="element-250">
          <StatBlock label="Pull-through" avg={stats.pullThrough.avg} min={stats.pullThrough.min} max={stats.pullThrough.max} format={(v: number) => `${v.toFixed(1)}%`} data-id="element-251" />
        </div>
        <div className="px-4" data-id="element-252">
          <StatBlock label="Clean File %" avg={stats.cleanPct.avg} min={stats.cleanPct.min} max={stats.cleanPct.max} format={(v: number) => `${v.toFixed(1)}%`} data-id="element-253" />
        </div>
        <div className="px-4" data-id="element-254">
          <StatBlock label="Avg Dials" avg={stats.dials.avg} min={stats.dials.min} max={stats.dials.max} format={(v: number) => v.toFixed(1)} reverse data-id="element-255" />
        </div>
        <div className="px-4" data-id="element-256">
          <StatBlock label="Cost / Funding" avg={stats.cost.avg} min={stats.cost.min} max={stats.cost.max} format={(v: number) => `$${v.toFixed(0)}`} reverse data-id="element-257" />
        </div>
      </div>
    </Card>;
}